import axios from "axios";
export default({
    state:{
        pager:{PageIndex:1,PageSize:5,PageTotal:0},
        informationText:null,
        time:''
    },
    mutations:{
        informationText(state,id){
            axios.post(`http://website.xiaoyu168.com/Public/SingleTradePress/${id}`).then(d=>{
                console.log(d.data);
            if(d.data&&d.data.Datum){
                state.informationText=d.data.Datum  
                state.time= new Date(parseInt(d.data.Datum.AddTime.replace(/[^0-9]/ig, ''))).format("yyyy-mm-dd")
                
            }
     
            })
        }
    }
    




})


// WEBPACK FOOTER //
// ./src/store/detail/index.js